/**
 * After-the-fact warning on the event page: a rep on this event's Sales Reps list has time off on one of its days
 * (e.g. the event was moved onto a day the rep marked as time off). A warning only -- nothing is changed or blocked.
 */
import React from "react";
import { useEventTimeOffConflicts } from "../../hooks/useTimeOff";
import { timeOffSentence } from "../../services/timeOffConflicts";

const TimeOffConflictBanner: React.FC<{ eventId: string }> = ({ eventId }) => {
  const { conflicts } = useEventTimeOffConflicts(eventId);
  if (conflicts.length === 0) {
    return null;
  }
  return (
    <div
      role="status"
      data-testid="time-off-conflict-banner"
      className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900"
    >
      <p className="font-medium">A rep on this event isn't marked available</p>
      <ul className="mt-1 list-disc pl-5">
        {conflicts.map((c) => (
          <li key={c.positionId}>
            {timeOffSentence(c.name, c.dates)} They're still on the Sales Reps
            list for {c.dates.length > 1 ? "those days" : "that day"}.
          </li>
        ))}
      </ul>
      <p className="mt-1 text-xs text-amber-800">
        Check with the rep, or change who works{" "}
        {conflicts.length > 1 ? "those days" : "that day"} on the Confirm
        Schedule tab.
      </p>
    </div>
  );
};

export default TimeOffConflictBanner;
